import { render, staticRenderFns } from "./ConfidentialityDataProcessingLetter.vue?vue&type=template&id=49494fbc&scoped=true"
import script from "./ConfidentialityDataProcessingLetter.vue?vue&type=script&lang=js"
export * from "./ConfidentialityDataProcessingLetter.vue?vue&type=script&lang=js"
import style0 from "./ConfidentialityDataProcessingLetter.vue?vue&type=style&index=0&id=49494fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49494fbc",
  null
  
)

export default component.exports